var map = {
	"./icon-add.svg": 68869,
	"./icon-arrow.svg": 51089,
	"./icon-arrow1.svg": 40936,
	"./icon-biography.svg": 13326,
	"./icon-chat.svg": 74533,
	"./icon-copy.svg": 54171,
	"./icon-friends.svg": 96864,
	"./icon-home.svg": 31218,
	"./icon-lucky.svg": 80480,
	"./icon-membership.svg": 46739,
	"./icon-ok.svg": 35686,
	"./icon-quest.svg": 62711,
	"./icon-rank.svg": 77241,
	"./icon-refresh.svg": 82037,
	"./icon-rewards.svg": 84167,
	"./icon-time.svg": 94375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;